import { CalendarOutlined, CloudOutlined, CodeOutlined, DesktopOutlined, GithubOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { useState } from 'react'
import { getSpringInfo } from './versionService'
import { Space } from 'antd'

const VERSION_REGEX = /^\d{8}\.\d+$/
const TIME_FORMAT = 'DD-MM-YYYY HH:mm'

const combineVersions = (frontendVersion: string, backendVersion: string): string => {
  const frontendParts = frontendVersion.split('.')
  const backendParts = backendVersion.split('.')

  const frontendDate = frontendParts[0]
  const backendDate = backendParts[0]
  const mostRecentDate = backendDate >= frontendDate ? backendDate : frontendDate

  const frontendRevision = frontendDate === mostRecentDate ? frontendParts[1] : '0'
  const backendRevision = backendDate === mostRecentDate ? backendParts[1] : '0'

  return `${mostRecentDate}.${frontendRevision}.${backendRevision}`
}

export const VersionInfo = () => {
  const { data: springInfo, isLoading } = getSpringInfo()
  const [hiddenDetails, setHiddenDetails] = useState<boolean>(true)
  const toggleDetails = () => {
    setHiddenDetails(prev => !prev)
  }

  const backendVersion = springInfo?.build?.version ?? ''
  const frontendVersion = import.meta.env.VITE_BUILD_VERSION ?? ''

  if (!springInfo?.build || isLoading || !VERSION_REGEX.test(backendVersion) || !VERSION_REGEX.test(frontendVersion)) {
    return <></>
  } else {
    const combinedVersion = combineVersions(frontendVersion, backendVersion)
    return <Space>
      <span onClick={toggleDetails}>
        {combinedVersion}
      </span>
      <Space direction='vertical' className="version-togglable">
        <div>
          <span hidden={hiddenDetails}>
            <CloudOutlined /> <span>{backendVersion}</span>
            &nbsp;<CalendarOutlined /> {dayjs(springInfo?.build.time).format(TIME_FORMAT)}
            &nbsp;<GithubOutlined /> {springInfo.build.git.commit.id}
            &nbsp;<CodeOutlined /> {springInfo.build.git.commit.message}
          </span>
        </div>
        <div>
          <span hidden={hiddenDetails}>
            <DesktopOutlined /> <span>{frontendVersion}</span>
            &nbsp;<CalendarOutlined /> {dayjs(import.meta.env.VITE_BUILD_DATETIME).format(TIME_FORMAT)}
            &nbsp;<GithubOutlined /> {import.meta.env.VITE_BUILD_COMMIT_ID ?? ''}
            &nbsp;<CodeOutlined /> {import.meta.env.VITE_BUILD_COMMIT_MESSAGE ?? ''}
          </span>
        </div>
      </Space>
    </Space>
  }
}
